import { Loader } from "Components";
import { RouteUrls } from "Constant/RouteUrls";
import { HeaderInitialStateType, UserInitialStateType } from "DataTypes/Redux";
import { addOrg, clearOrg } from "Redux/Header/Action";
import { setAlertData, stopLoading } from "Redux/Screen/Action";
import CommonFormatter from "Utils/Common.Formatter";
import { ConvertStringToNum } from "Utils/common";
import { FC, Suspense, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import PracticeApi from "Service/Practice.api";
import OrganizationFormatter from "Utils/Organization.Formatter";
import RouteFallback from "RouteFallback";

const OrganizationStaff: FC = () => {
  const { orgId } = useParams();
  const newOrgId = ConvertStringToNum(orgId);
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { organization }: HeaderInitialStateType = useSelector(
    (state: any) => state?.header
  );
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    loadOrganization();
    return () => {
      dispatch(clearOrg());
    };
  }, [newOrgId]);

  const loadOrganization: () => Promise<void> = async () => {
    setLoader(true);
    let nextOrganization = organization;
    if (newOrgId == myInfo.practiceId) {
      nextOrganization = {
        id: myInfo.practiceId || null,
        name: myInfo.practiceName,
        masterPractice: myInfo.isMasterPractice,
        modelId: myInfo.practiceModelId,
        modelName: myInfo.practiceModelName,
      };
    } else if (newOrgId != organization.id) {
      const orgRes = await PracticeApi.read({ id1: newOrgId });
      if (!orgRes?.success) {
        dispatch(setAlertData(orgRes?.alert));
        dispatch(stopLoading());
        navigate(-1);
        return;
      }
      const readOrganization =
        OrganizationFormatter.VerifyReadResponse(orgRes.data);
      nextOrganization = {
        id: readOrganization.id ?? null,
        name: readOrganization.name,
        masterPractice: readOrganization.masterPractice,
        modelId: readOrganization.businessModels.id,
        modelName: readOrganization.businessModels.name ?? "",
      };
    }
    dispatch(addOrg(nextOrganization));
    CommonFormatter.HandleNavArr({
      id: "org-list",
      label: nextOrganization.name,
      path: `/${RouteUrls.hs}/${RouteUrls.organization}` +
        `/${nextOrganization.id}/${RouteUrls.staff}/${RouteUrls.list}`,
      level: 2,
      link: RouteUrls.list,
      navType: "org",
    });
    setLoader(false);
  };

  return loader ? (
    <Loader />
  ) : (
    <Suspense fallback={<RouteFallback />}>
      <Outlet />
    </Suspense>
  );
};
export default OrganizationStaff;
